// @flow
import * as React from 'react';
import HeaderHeight from 'app/common/react/components/Header/Context/Context';
import {
  HEADER_DEFAULT_HEIGHT,
  HEADER_ID,
} from 'app/common/react/components/Header/HeaderConstants';

type Props = {|
  children: React.Node,
|};

type State = {|
  height: number,
|};

const observerConfig = {
  childList: true,
  attributes: true,
  subtree: true,
};

class HeaderHeightProvider extends React.Component<Props, State> {
  state = { height: HEADER_DEFAULT_HEIGHT };

  componentDidMount() {
    const header = document.getElementById(HEADER_ID);

    if (header) {
      this.mutationObserver = new MutationObserver(this.handleMutation(header));
      this.mutationObserver.observe(header, observerConfig);
    }
  }

  componentWillUnmount() {
    if (this.mutationObserver) {
      this.mutationObserver.disconnect();
    }
  }

  mutationObserver: MutationObserver;

  handleMutation = (header: HTMLElement) => () => this.setState({ height: header.clientHeight });

  render() {
    const { children } = this.props;
    const { height } = this.state;
    return <HeaderHeight.Provider value={height}>{children}</HeaderHeight.Provider>;
  }
}

export default HeaderHeightProvider;
